import { html, render } from 'lit-html'
import styles from './spinner.css'

export class PomodoroSpinner extends HTMLElement {
  shadow: ShadowRoot

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  connectedCallback(): void {
    this.render()
  }

  render(): void {
    const template = html`
      <style>
        ${styles}
      </style>
      <div class="parent">
        <div></div>
        <div></div>
        <div></div>
      </div>
    `
    render(template, this.shadow, { host: this })
  }
}

customElements.define('pomodoro-spinner', PomodoroSpinner)
